const colorTermList= [
    {
      "CMYK": (4, 5, 18, 0),
      "rgb": (249, 244, 220),
      "color": "#f9f4dc",
      "title": "乳白",
      "Py": "rubai"
    },
    {
      "CMYK": (3, 8, 30, 0),
      "rgb": (249, 236, 195),
      "color": "#f7e8aa",
      "title": "杏仁黄",
      "Py": "xingrenhuang"
    },
    {
      "CMYK": (4, 13, 67, 0),
      "rgb": (248, 223, 114),
      "color": "#f8df72",
      "title": "茉莉黄",
      "Py": "molihuang"
    },
    {
      "CMYK": (5, 14, 68, 1),
      "rgb": (248, 223, 112),
      "color": "#f8df70",
      "title": "麦秆黄",
      "Py": "maiganhuang"
    },
    {
      "CMYK": (2, 16, 84, 0),
      "rgb": (251, 218, 65),
      "color": "#fbda41",
      "title": "油菜花黄",
      "Py": "youcaihuahuang"
    },
    {
      "CMYK": (1, 18, 94, 0),
      "rgb": (254, 215, 26),
      "color": "#fed71a",
      "title": "佛手黄",
      "Py": "foshouhuang"
    },
    {
      "CMYK": (3, 16, 50, 0),
      "rgb": (247, 222, 152),
      "color": "#f7de98",
      "title": "篾黄",
      "Py": "miehuang"
    },
    {
      "CMYK": (3, 17, 69, 0),
      "rgb": (248, 216, 106),
      "color": "#f8d86a",
      "title": "葵扇黄",
      "Py": "kuishanhuang"
    },
    {
      "CMYK": (0, 20, 87, 0),
      "rgb": (252, 211, 55),
      "color": "#fcd337",
      "title": "柠檬黄",
      "Py": "ningmenghuang"
    },
    {
      "CMYK": (0, 20, 95, 0),
      "rgb": (252, 210, 23),
      "color": "#fcd217",
      "title": "金瓜黄",
      "Py": "jinguahuang"
    },
    {
      "CMYK": (0, 21, 94, 0),
      "rgb": (254, 209, 16),
      "color": "#ffd111",
      "title": "藤黄",
      "Py": "tenghuang"
    },
    {
      "CMYK": (2, 16, 39, 0),
      "rgb": (246, 222, 173),
      "color": "#f6dead",
      "title": "酪黄",
      "Py": "laohuang"
    },
    {
      "CMYK": (1, 21, 70, 0),
      "rgb": (249, 211, 103),
      "color": "#f9d367",
      "title": "淡密黄",
      "Py": "danmihuang"
    },
    {
      "CMYK": (0, 23, 88, 0),
      "rgb": (251, 205, 49),
      "color": "#fbcd31",
      "title": "大豆黄",
      "Py": "dadouhuang"
    },
    {
      "CMYK": (0, 24, 94, 0),
      "rgb": (252, 203, 22),
      "color": "#fccb16",
      "title": "素馨黄",
      "Py": "suxinhuang"
    },
    {
      "CMYK": (0, 24, 94, 0),
      "rgb": (254, 204, 17),
      "color": "#fecc11",
      "title": "向日葵黄",
      "Py": "xiangrikuihuang"
    },
    {
      "CMYK": (0, 27, 88, 0),
      "rgb": (251, 200, 47),
      "color": "#fbc82f",
      "title": "雅梨黄",
      "Py": "yalihuang"
    },
    {
      "CMYK": (0, 28, 94, 0),
      "rgb": (252, 197, 21),
      "color": "#fcc515",
      "title": "黄连黄",
      "Py": "huanglianhuang"
    },
    {
      "CMYK": (0, 29, 95, 0),
      "rgb": (252, 195, 7),
      "color": "#fcc307",
      "title": "金盏黄",
      "Py": "jinzhanhuang"
    },
    {
      "CMYK": (0, 32, 52, 0),
      "rgb": (248, 195, 135),
      "color": "#f8c387",
      "title": "蛋壳黄",
      "Py": "dankehuang"
    },
    {
      "CMYK": (0, 32, 52, 0),
      "rgb": (247, 193, 115),
      "color": "#f7c173",
      "title": "肉色",
      "Py": "rouse"
    },
    {
      "CMYK": (0, 35, 89, 0),
      "rgb": (251, 185, 41),
      "color": "#fbb929",
      "title": "鹅掌黄",
      "Py": "ezhanghuang"
    },
    {
      "CMYK": (0, 36, 93, 0),
      "rgb": (251, 182, 18),
      "color": "#fbb612",
      "title": "鸡蛋黄",
      "Py": "jidanhuang"
    },
    {
      "CMYK": (0, 35, 94, 0),
      "rgb": (252, 183, 10),
      "color": "#fcb70a",
      "title": "鼬黄",
      "Py": "youhuang"
    },
    {
      "CMYK": (0, 44, 84, 0),
      "rgb": (249, 166, 51),
      "color": "#f9a633",
      "title": "榴萼黄",
      "Py": "liuehuang"
    },
    {
      "CMYK": (0, 45, 92, 0),
      "rgb": (251, 164, 20),
      "color": "#fba414",
      "title": "淡橘橙",
      "Py": "danjucheng"
    },
    {
      "CMYK": (0, 47, 92, 0),
      "rgb": (252, 161, 6),
      "color": "#fca106",
      "title": "枇杷黄",
      "Py": "pipahuang"
    },
    {
      "CMYK": (0, 47, 92, 0),
      "rgb": (252, 161, 4),
      "color": "#fca104",
      "title": "橙皮黄",
      "Py": "chengpihuang"
    },
    {
      "CMYK": (0, 56, 87, 0),
      "rgb": (252, 140, 35),
      "color": "#fc8c23",
      "title": "北瓜黄",
      "Py": "beiguahuang"
    },
    {
      "CMYK": (0, 54, 92, 0),
      "rgb": (250, 142, 22),
      "color": "#f28e16",
      "title": "杏黄",
      "Py": "xinghuang"
    },
    {
      "CMYK": (0, 51, 91, 0),
      "rgb": (255, 153, 0),
      "color": "#ff9900",
      "title": "雄黄",
      "Py": "xionghuang"
    },
    {
      "CMYK": (0, 56, 91, 0),
      "rgb": (251, 139, 5),
      "color": "#fb8b05",
      "title": "万寿菊黄",
      "Py": "wanshoujuhuang"
    },
    {
      "CMYK": (10, 13, 35, 1),
      "rgb": (233, 221, 182),
      "color": "#e9ddb6",
      "title": "菊蕾白",
      "Py": "juleibai"
    },
    {
      "CMYK": (8, 19, 84, 1),
      "rgb": (238, 208, 69),
      "color": "#eed045",
      "title": "秋葵黄",
      "Py": "qiukuihuang"
    },
    {
      "CMYK": (6, 20, 92, 1),
      "rgb": (242, 206, 43),
      "color": "#f2ce2b",
      "title": "硫华黄",
      "Py": "liuhuahuang"
    },
    {
      "CMYK": (6, 22, 92, 0),
      "rgb": (241, 202, 23),
      "color": "#f1ca17",
      "title": "柚黄",
      "Py": "youhuang"
    },
    {
      "CMYK": (15, 20, 66, 2),
      "rgb": (221, 200, 113),
      "color": "#ddc871",
      "title": "芒果黄",
      "Py": "mangguohuang"
    },
    {
      "CMYK": (14, 22, 85, 2),
      "rgb": (223, 194, 67),
      "color": "#dfc243",
      "title": "蒿黄",
      "Py": "haohuang"
    },
    {
      "CMYK": (12, 24, 95, 2),
      "rgb": (226, 192, 39),
      "color": "#e2c027",
      "title": "姜黄",
      "Py": "jianghuang"
    },
    {
      "CMYK": (11, 25, 99, 1),
      "rgb": (228, 191, 17),
      "color": "#e4bf11",
      "title": "香蕉黄",
      "Py": "xiangjiaohuang"
    },
    {
      "CMYK": (17, 27, 94, 4),
      "rgb": (210, 180, 44),
      "color": "#d2b42c",
      "title": "草黄",
      "Py": "caohuang"
    },
    {
      "CMYK": (17, 29, 100, 4),
      "rgb": (210, 177, 22),
      "color": "#d2b116",
      "title": "新禾绿",
      "Py": "xinhelv"
    },
    {
      "CMYK": (28, 26, 45, 7),
      "rgb": (183, 174, 143),
      "color": "#b7ae8f",
      "title": "月灰",
      "Py": "yuehui"
    },
    {
      "CMYK": (30, 30, 70, 12),
      "rgb": (173, 158, 85),
      "color": "#ad9e5f",
      "title": "淡灰绿",
      "Py": "danhuilv"
    },
    {
      "CMYK": (38, 38, 76, 24),
      "rgb": (142, 128, 75),
      "color": "#8e804b",
      "title": "草灰绿",
      "Py": "caohuilv"
    },
    {
      "CMYK": (36, 42, 100, 29),
      "rgb": (136, 115, 34),
      "color": "#887322",
      "title": "苔绿",
      "Py": "tailv"
    },
    {
      "CMYK": (36, 42, 100, 30),
      "rgb": (134, 112, 24),
      "color": "#867018",
      "title": "碧螺春绿",
      "Py": "biluochunlv"
    },
    {
      "CMYK": (47, 47, 65, 42),
      "rgb": (104, 94, 72),
      "color": "#685e48",
      "title": "燕羽灰",
      "Py": "yanyuhui"
    },
    {
      "CMYK": (46, 47, 69, 42),
      "rgb": (105, 94, 69),
      "color": "#695e45",
      "title": "蟹壳灰",
      "Py": "xiekehui"
    },
    {
      "CMYK": (48, 48, 100, 45),
      "rgb": (100, 88, 34),
      "color": "#645822",
      "title": "潭水绿",
      "Py": "tanshuilv"
    },
    {
      "CMYK": (50, 50, 10, 48),
      "rgb": (94, 83, 20),
      "color": "#5e5314",
      "title": "橄榄绿",
      "Py": "ganlanlv"
    },
    {
      "CMYK": (2, 6, 18, 0),
      "rgb": (249, 241, 219),
      "color": "#f9f1db",
      "title": "蚌肉白",
      "Py": "bangroubai"
    },
    {
      "CMYK": (3, 10, 31, 0),
      "rgb": (248, 232, 193),
      "color": "#f8e8c1",
      "title": "豆汁黄",
      "Py": "douzhihuang"
    },
    {
      "CMYK": (1, 19, 66, 0),
      "rgb": (249, 215, 112),
      "color": "#f9d770",
      "title": "淡茧黄",
      "Py": "danjianhuang"
    },
    {
      "CMYK": (0, 26, 94, 0),
      "rgb": (255, 201, 12),
      "color": "#ffc90c",
      "title": "乳鸭黄",
      "Py": "ruyahuang"
    },
    {
      "CMYK": (5, 11, 22, 0),
      "rgb": (242, 230, 206),
      "color": "#f2e6ce",
      "title": "荔肉白",
      "Py": "liroubai"
    },
    {
      "CMYK": (5, 19, 50, 0),
      "rgb": (240, 214, 149),
      "color": "#f0d695",
      "title": "象牙黄",
      "Py": "xiangyahuang"
    },
    {
      "CMYK": (3, 23, 69, 0),
      "rgb": (244, 206, 105),
      "color": "#f4ce69",
      "title": "炒米黄",
      "Py": "chaomihuang"
    },
    {
      "CMYK": (1, 28, 89, 0),
      "rgb": (246, 196, 48),
      "color": "#f6c430",
      "title": "鹦鹉冠黄",
      "Py": "yingwuguanhuang"
    },
    {
      "CMYK": (0, 30, 95, 0),
      "rgb": (249, 193, 22),
      "color": "#f9c116",
      "title": "木瓜黄",
      "Py": "muguahuang"
    },
    {
      "CMYK": (0, 32, 95, 0),
      "rgb": (249, 189, 16),
      "color": "#f9bd10",
      "title": "浅烙黄",
      "Py": "qianlaohuang"
    },
    {
      "CMYK": (11, 18, 39, 1),
      "rgb": (229, 211, 170),
      "color": "#e5d3aa",
      "title": "莲子白",
      "Py": "lianzibai"
    },
    {
      "CMYK": (5, 35, 99, 0),
      "rgb": (232, 176, 4),
      "color": "#e8b004",
      "title": "谷黄",
      "Py": "guhuang"
    },
    {
      "CMYK": (3, 36, 99, 0),
      "rgb": (235, 177, 13),
      "color": "#ebb10d",
      "title": "栀子黄",
      "Py": "zhizihuang"
    },
    {
      "CMYK": (11, 39, 100, 2),
      "rgb": (217, 164, 14),
      "color": "#d9a40e",
      "title": "芥黄",
      "Py": "jiehuang"
    },
    {
      "CMYK": (28, 27, 43, 8),
      "rgb": (181, 170, 144),
      "color": "#b5aa90",
      "title": "银鼠灰",
      "Py": "yinshuhui"
    },
    {
      "CMYK": (26, 31, 57, 10),
      "rgb": (182, 164, 118),
      "color": "#b6a476",
      "title": "尘灰",
      "Py": "chenhui"
    },
    {
      "CMYK": (21, 43, 100, 11),
      "rgb": (183, 141, 18),
      "color": "#b78d12",
      "title": "枯绿",
      "Py": "kulv"
    },
    {
      "CMYK": (35, 44, 80, 30),
      "rgb": (135, 114, 62),
      "color": "#87723e",
      "title": "鲛青",
      "Py": "jiaoqing"
    },
    {
      "CMYK": (32, 50, 100, 31),
      "rgb": (135, 104, 24),
      "color": "#876818",
      "title": "粽叶绿",
      "Py": "zongyelv"
    },
    {
      "CMYK": (31, 51, 100, 30),
      "rgb": (138, 105, 19),
      "color": "#8a6913",
      "title": "灰绿",
      "Py": "huilv"
    },
    {
      "CMYK": (52, 56, 64, 62),
      "rgb": (74, 64, 53),
      "color": "#4a4035",
      "title": "鹤灰",
      "Py": "hehui"
    },
    {
      "CMYK": (48, 58, 70, 62),
      "rgb": (77, 64, 48),
      "color": "#4d4030",
      "title": "淡松烟",
      "Py": "dansongyan"
    },
    {
      "CMYK": (45, 56, 100, 56),
      "rgb": (88, 71, 23),
      "color": "#584717",
      "title": "暗海水绿",
      "Py": "anhaishuilv"
    },
    {
      "CMYK": (45, 55, 100, 54),
      "rgb": (91, 73, 19),
      "color": "#5b4913",
      "title": "棕榈绿",
      "Py": "zonglvlv"
    },
    {
      "CMYK": (1, 11, 24, 0),
      "rgb": (249, 223, 205),
      "color": "#f9e9cd",
      "title": "米色",
      "Py": "mise"
    },
    {
      "CMYK": (1, 15, 38, 0),
      "rgb": (248, 224, 176),
      "color": "#f8e0b0",
      "title": "淡肉色",
      "Py": "danrouse"
    },
    {
      "CMYK": (0, 23, 59, 0),
      "rgb": (249, 210, 125),
      "color": "#f9d27d",
      "title": "麦芽糖黄",
      "Py": "maiyatanghuang"
    },
    {
      "CMYK": (0, 34, 93, 0),
      "rgb": (254, 186, 7),
      "color": "#feba07",
      "title": "琥珀黄",
      "Py": "hupohuang"
    },
    {
      "CMYK": (1, 31, 79, 0),
      "rgb": (243, 191, 76),
      "color": "#f3bf4c",
      "title": "甘草黄",
      "Py": "gancaohuang"
    },
    {
      "CMYK": (0, 33, 83, 0),
      "rgb": (248, 188, 49),
      "color": "#f8bc31",
      "title": "初熟杏黄",
      "Py": "chushuxinghuang"
    },
    {
      "CMYK": (10, 27, 59, 1),
      "rgb": (226, 193, 124),
      "color": "#e2c17c",
      "title": "浅驼色",
      "Py": "qiantuose"
    },
    {
      "CMYK": (7, 32, 78, 1),
      "rgb": (229, 183, 81),
      "color": "#e5b751",
      "title": "沙石黄",
      "Py": "shashihuang"
    },
    {
      "CMYK": (3, 38, 97, 0),
      "rgb": (234, 173, 26),
      "color": "#eaad1a",
      "title": "虎皮黄",
      "Py": "hupihuang"
    },
    {
      "CMYK": (12, 41, 98, 2),
      "rgb": (214, 160, 29),
      "color": "#d6a01d",
      "title": "土黄",
      "Py": "tuhuang"
    },
    {
      "CMYK": (28, 28, 41, 9),
      "rgb": (180, 169, 146),
      "color": "#b4a992",
      "title": "百灵鸟灰",
      "Py": "bailingniaohui"
    },
    {
      "CMYK": (21, 44, 97, 11),
      "rgb": (183, 139, 38),
      "color": "#b78b26",
      "title": "山鸡黄",
      "Py": "shanjihuang"
    },
    {
      "CMYK": (35, 47, 71, 33),
      "rgb": (130, 107, 72),
      "color": "#826b48",
      "title": "龟背黄",
      "Py": "guibeihuang"
    },
    {
      "CMYK": (34, 52, 85, 35),
      "rgb": (128, 99, 50),
      "color": "#806332",
      "title": "苍黄",
      "Py": "canghuang"
    },
    {
      "CMYK": (32, 56, 96, 34),
      "rgb": (129, 95, 37),
      "color": "#815f25",
      "title": "莱阳梨黄",
      "Py": "laiyanglihuang"
    },
    {
      "CMYK": (31, 57, 100, 33),
      "rgb": (131, 94, 29),
      "color": "#835e1d",
      "title": "蜴蜊绿",
      "Py": "yililv"
    },
    {
      "CMYK": (46, 59, 68, 61),
      "rgb": (79, 64, 50),
      "color": "#4f4032",
      "title": "松鼠灰",
      "Py": "songshuhui"
    },
    {
      "CMYK": (44, 61, 76, 62),
      "rgb": (80, 62, 42),
      "color": "#503e2a",
      "title": "橄榄灰",
      "Py": "ganlanhui"
    },
    {
      "CMYK": (43, 63, 88, 61),
      "rgb": (81, 60, 32),
      "color": "#513c20",
      "title": "蟹壳绿",
      "Py": "xiekelv"
    },
    {
      "CMYK": (42, 64, 94, 60),
      "rgb": (83, 60, 27),
      "color": "#533c1b",
      "title": "古铜绿",
      "Py": "gutonglv"
    },
    {
      "CMYK": (41, 66, 94, 60),
      "rgb": (85, 59, 24),
      "color": "#553b18",
      "title": "焦茶绿",
      "Py": "jiaochalv"
    },
    {
      "CMYK": (1, 7, 13, 0),
      "rgb": (251, 242, 227),
      "color": "#fbf2e3",
      "title": "粉白",
      "Py": "fenbai"
    },
    {
      "CMYK": (1, 12, 22, 0),
      "rgb": (249, 232, 208),
      "color": "#f9e8d0",
      "title": "落英淡粉",
      "Py": "luoyingdanfen"
    },
    {
      "CMYK": (0, 27, 51, 0),
      "rgb": (249, 203, 139),
      "color": "#f9cb8b",
      "title": "瓜瓤粉",
      "Py": "guarangfen"
    },
    {
      "CMYK": (0, 36, 72, 0),
      "rgb": (251, 185, 87),
      "color": "#fbb957",
      "title": "蜜黄",
      "Py": "mihuang"
    },
    {
      "CMYK": (0, 44, 91, 0),
      "rgb": (255, 166, 15),
      "color": "#ffa60f",
      "title": "金叶黄",
      "Py": "jinyehuang"
    },
    {
      "CMYK": (0, 43, 82, 0),
      "rgb": (244, 168, 58),
      "color": "#f4a83a",
      "title": "金莺黄",
      "Py": "jinyinghuang"
    },
    {
      "CMYK": (8, 31, 50, 1),
      "rgb": (227, 189, 141),
      "color": "#e3bd8d",
      "title": "鹿角棕",
      "Py": "lujiaozong"
    },
    {
      "CMYK": (2, 44, 83, 0),
      "rgb": (231, 162, 63),
      "color": "#e7a23f",
      "title": "凋叶棕",
      "Py": "diaoyezong"
    },
    {
      "CMYK": (10, 41, 72, 1),
      "rgb": (218, 164, 90),
      "color": "#daa45a",
      "title": "玳瑁黄",
      "Py": "daimaohuang"
    },
    {
      "CMYK": (7, 45, 82, 1),
      "rgb": (222, 158, 68),
      "color": "#de9e44",
      "title": "软木黄",
      "Py": "ruanmuhuang"
    },
    {
      "CMYK": (6, 51, 95, 1),
      "rgb": (220, 145, 35),
      "color": "#dc9123",
      "title": "风帆黄",
      "Py": "fengfanhuang"
    },
    {
      "CMYK": (19, 44, 75, 7),
      "rgb": (192, 147, 81),
      "color": "#c09351",
      "title": "桂皮淡棕",
      "Py": "guipidanzong"
    },
    {
      "CMYK": (32, 40, 53, 22),
      "rgb": (151, 132, 108),
      "color": "#97846c",
      "title": "猴毛灰",
      "Py": "houmaohui"
    },
    {
      "CMYK": (27, 60, 97, 21),
      "rgb": (152, 101, 36),
      "color": "#986524",
      "title": "山鸡褐",
      "Py": "shanjihe"
    },
    {
      "CMYK": (37, 65, 84, 49),
      "rgb": (102, 70, 42),
      "color": "#66462a",
      "title": "驼色",
      "Py": "tuose"
    },
    {
      "CMYK": (38, 69, 90, 54),
      "rgb": (93, 61, 33),
      "color": "#5d3d21",
      "title": "茶褐",
      "Py": "chahe"
    },
    {
      "CMYK": (37, 74, 96, 55),
      "rgb": (92, 55, 25),
      "color": "#5c3719",
      "title": "古铜褐",
      "Py": "gutonghe"
    },
    {
      "CMYK": (0, 10, 14, 0),
      "rgb": (251, 236, 222),
      "color": "#fbecde",
      "title": "荷花白",
      "Py": "hehuabai"
    },
    {
      "CMYK": (0, 40, 52, 0),
      "rgb": (248, 179, 127),
      "color": "#f8b37f",
      "title": "玫瑰粉",
      "Py": "meiguifen"
    },
    {
      "CMYK": (0, 62, 88, 0),
      "rgb": (249, 125, 28),
      "color": "#f97d1c",
      "title": "橘橙",
      "Py": "jucheng"
    },
    {
      "CMYK": (0, 62, 85, 0),
      "rgb": (250, 126, 35),
      "color": "#fa7e23",
      "title": "美人焦橙",
      "Py": "meirenjiaocheng"
    },
    {
      "CMYK": (0, 28, 25, 0),
      "rgb": (247, 205, 188),
      "color": "#f7cdbc",
      "title": "润红",
      "Py": "runhong"
    },
    {
      "CMYK": (0, 28, 22, 0),
      "rgb": (246, 206, 193),
      "color": "#f6cec1",
      "title": "淡桃红",
      "Py": "dantaohong"
    },
    {
      "CMYK": (0, 53, 65, 0),
      "rgb": (240, 148, 93),
      "color": "#f0945d",
      "title": "海螺橙",
      "Py": "hailuocheng"
    },
    {
      "CMYK": (0, 44, 32, 0),
      "rgb": (240, 173, 160),
      "color": "#f0ada0",
      "title": "桃红",
      "Py": "taohong"
    },
    {
      "CMYK": (0, 45, 34, 0),
      "rgb": (238, 170, 156),
      "color": "#eeaa9c",
      "title": "颊红",
      "Py": "jiahong"
    },
    {
      "CMYK": (0, 49, 41, 0),
      "rgb": (238, 160, 140),
      "color": "#eea08c",
      "title": "淡罂粟红",
      "Py": "danyingsuhong"
    },
    {
      "CMYK": (0, 58, 67, 0),
      "rgb": (234, 137, 88),
      "color": "#ea8958",
      "title": "晨曦红",
      "Py": "chenxihong"
    },
    {
      "CMYK": (0, 65, 80, 0),
      "rgb": (242, 118, 53),
      "color": "#f27635",
      "title": "蟹壳红",
      "Py": "xiekehong"
    },
    {
      "CMYK": (0, 69, 86, 0),
      "rgb": (248, 107, 29),
      "color": "#f86b1d",
      "title": "金莲花橙",
      "Py": "jinlianhuacheng"
    },
    {
      "CMYK": (0, 69, 70, 0),
      "rgb": (239, 111, 72),
      "color": "#ef6f48",
      "title": "草莓红",
      "Py": "caomeihong"
    },
    {
      "CMYK": (0, 72, 82, 0),
      "rgb": (239, 99, 43),
      "color": "#ef632b",
      "title": "龙睛鱼红",
      "Py": "longjingyuhong"
    },
    {
      "CMYK": (0, 81, 84, 0),
      "rgb": (241, 68, 29),
      "color": "#f1441d",
      "title": "蜻蜓红",
      "Py": "qingtinghong"
    },
    {
      "CMYK": (0, 80, 83, 0),
      "rgb": (240, 75, 34),
      "color": "#f04b22",
      "title": "大红",
      "Py": "dahong"
    },
    {
      "CMYK": (0, 80, 85, 0),
      "rgb": (242, 72, 27),
      "color": "#f2481b",
      "title": "柿红",
      "Py": "shihong"
    },
    {
      "CMYK": (0, 80, 85, 0),
      "rgb": (243, 71, 24),
      "color": "#f34718",
      "title": "榴花红",
      "Py": "liuhuahong"
    },
    {
      "CMYK": (0, 83, 87, 0),
      "rgb": (244, 62, 6),
      "color": "#f43e06",
      "title": "银朱",
      "Py": "yinzhu"
    },
    {
      "CMYK": (0, 78, 83, 0),
      "rgb": (237, 81, 38),
      "color": "#ed5126",
      "title": "朱红",
      "Py": "zhuhong"
    },
    {
      "CMYK": (0, 50, 68, 0),
      "rgb": (240, 156, 90),
      "color": "#f09c5a",
      "title": "鲑鱼红",
      "Py": "guiyuhong"
    },
    {
      "CMYK": (5, 69, 87, 0),
      "rgb": (242, 123, 31),
      "color": "#f26b1f",
      "title": "金黄",
      "Py": "jinhuang"
    },
    {
      "CMYK": (7, 52, 71, 1),
      "rgb": (217, 145, 86),
      "color": "#d99156",
      "title": "鹿皮褐",
      "Py": "lupihe"
    },
    {
      "CMYK": (4, 57, 82, 1),
      "rgb": (219, 133, 64),
      "color": "#db8540",
      "title": "醉瓜肉",
      "Py": "zuiguarou"
    },
    {
      "CMYK": (0, 64, 93, 0),
      "rgb": (222, 118, 34),
      "color": "#de7622",
      "title": "麂棕",
      "Py": "jizong"
    },
    {
      "CMYK": (22, 28, 34, 6),
      "rgb": (193, 178, 163),
      "color": "#c1b2a3",
      "title": "淡银灰",
      "Py": "danyinhui"
    },
    {
      "CMYK": (18, 57, 76, 6),
      "rgb": (190, 126, 74),
      "color": "#be7e4a",
      "title": "淡赭",
      "Py": "danzhe"
    },
    {
      "CMYK": (14, 69, 100, 4),
      "rgb": (193, 101, 26),
      "color": "#c1651a",
      "title": "槟榔综",
      "Py": "binglangzong"
    },
    {
      "CMYK": (34, 42, 46, 23),
      "rgb": (145, 128, 114),
      "color": "#918072",
      "title": "银灰",
      "Py": "yinhui"
    },
    {
      "CMYK": (42, 40, 46, 20),
      "rgb": (154, 136, 120),
      "color": "#9a8878",
      "title": "海鸥灰",
      "Py": "haiouhui"
    },
    {
      "CMYK": (27, 69, 85, 22),
      "rgb": (148, 88, 51),
      "color": "#945833",
      "title": "淡咖啡",
      "Py": "dankafei"
    },
    {
      "CMYK": (26, 76, 97, 20),
      "rgb": (150, 77, 34),
      "color": "#964d22",
      "title": "岩石棕",
      "Py": "yanshizong"
    },
    {
      "CMYK": (25, 80, 100, 20),
      "rgb": (149, 68, 22),
      "color": "#954416",
      "title": "芒果棕",
      "Py": "mangguozong"
    },
    {
      "CMYK": (39, 60, 58, 51),
      "rgb": (98, 73, 65),
      "color": "#624941",
      "title": "石板灰",
      "Py": "shibanhui"
    },
    {
      "CMYK": (38, 63, 63, 50),
      "rgb": (100, 72, 61),
      "color": "#64483d",
      "title": "珠母灰",
      "Py": "zhumuhui"
    },
    {
      "CMYK": (32, 83, 96, 41),
      "rgb": (113, 54, 29),
      "color": "#71361d",
      "title": "丁香棕",
      "Py": "dingxiangzong"
    },
    {
      "CMYK": (30, 87, 100, 38),
      "rgb": (117, 49, 23),
      "color": "#753117",
      "title": "咖啡",
      "Py": "kafei"
    },
    {
      "CMYK": (30, 89, 100, 39),
      "rgb": (115, 46, 18),
      "color": "#732e12",
      "title": "筍皮棕",
      "Py": "sunpizong"
    },
    {
      "CMYK": (0, 72, 86, 0),
      "rgb": (252, 99, 21),
      "color": "#fc6315",
      "title": "燕颔红",
      "Py": "yanhanhong"
    },
    {
      "CMYK": (3, 38, 39, 0),
      "rgb": (232, 180, 154),
      "color": "#e8b49a",
      "title": "玉粉红",
      "Py": "yufenhong"
    },
    {
      "CMYK": (0, 70, 87, 0),
      "rgb": (228, 104, 40),
      "color": "#e46828",
      "title": "金驼",
      "Py": "jintuo"
    },
    {
      "CMYK": (0, 76, 97, 0),
      "rgb": (216, 89, 22),
      "color": "#d85916",
      "title": "铁棕",
      "Py": "tiezong"
    },
    {
      "CMYK": (23, 35, 38, 10),
      "rgb": (183, 160, 145),
      "color": "#b7a091",
      "title": "蛛网灰",
      "Py": "zhuwanghui"
    },
    {
      "CMYK": (16, 77, 100, 6),
      "rgb": (183, 81, 29),
      "color": "#b7511d",
      "title": "淡可可棕",
      "Py": "dankekezong"
    },
    {
      "CMYK": (31, 63, 66, 31),
      "rgb": (139, 97, 77),
      "color": "#8b614d",
      "title": "中红灰",
      "Py": "zhonghonghui"
    },
    {
      "CMYK": (28, 76, 82, 26),
      "rgb": (140, 75, 49),
      "color": "#8c4b31",
      "title": "淡土黄",
      "Py": "dantuhuang"
    },
    {
      "CMYK": (28, 83, 92, 28),
      "rgb": (135, 61, 36),
      "color": "#873d24",
      "title": "淡豆沙",
      "Py": "dandousha"
    },
    {
      "CMYK": (27, 85, 98, 27),
      "rgb": (136, 58, 30),
      "color": "#883a1e",
      "title": "椰壳棕",
      "Py": "yekezong"
    },
    {
      "CMYK": (40, 64, 61, 56),
      "rgb": (91, 66, 58),
      "color": "#5b423a",
      "title": "淡铁灰",
      "Py": "dantiehui"
    },
    {
      "CMYK": (37, 72, 72, 52),
      "rgb": (96, 61, 48),
      "color": "#603d30",
      "title": "中灰驼",
      "Py": "zhonghuituo"
    },
    {
      "CMYK": (34, 82, 85, 47),
      "rgb": (103, 52, 36),
      "color": "#673424",
      "title": "淡栗棕",
      "Py": "danlizong"
    },
    {
      "CMYK": (33, 89, 92, 48),
      "rgb": (101, 43, 28),
      "color": "#652b1c",
      "title": "可可棕",
      "Py": "kekezong"
    },
    {
      "CMYK": (32, 90, 95, 45),
      "rgb": (105, 42, 27),
      "color": "#692a1b",
      "title": "柞叶棕",
      "Py": "zhayezong"
    },
    {
      "CMYK": (0, 53, 59, 0),
      "rgb": (251, 153, 104),
      "color": "#fb9968",
      "title": "野蔷薇红",
      "Py": "yeqiangweihong"
    },
    {
      "CMYK": (0, 65, 79, 0),
      "rgb": (252, 121, 48),
      "color": "#fc7930",
      "title": "菠萝红",
      "Py": "boluohong"
    },
    {
      "CMYK": (2, 31, 31, 0),
      "rgb": (237, 195, 174),
      "color": "#edc3ae",
      "title": "藕荷",
      "Py": "ouhe"
    },
    {
      "CMYK": (0, 70, 91, 0),
      "rgb": (225, 103, 35),
      "color": "#e16723",
      "title": "陶瓷红",
      "Py": "taocihong"
    },
    {
      "CMYK": (16, 23, 27, 2),
      "rgb": (212, 196, 183),
      "color": "#d4c4b7",
      "title": "晓灰",
      "Py": "xiaohui"
    },
    {
      "CMYK": (9, 64, 78, 1),
      "rgb": (207, 117, 67),
      "color": "#cf7543",
      "title": "余烬红",
      "Py": "yujinhong"
    },
    {
      "CMYK": (8, 72, 93, 1),
      "rgb": (205, 98, 39),
      "color": "#cd6227",
      "title": "火砖红",
      "Py": "huozhuanhong"
    },
    {
      "CMYK": (22, 64, 71, 12),
      "rgb": (170, 106, 76),
      "color": "#aa6a4c",
      "title": "火泥棕",
      "Py": "huonizong"
    },
    {
      "CMYK": (20, 76, 92, 9),
      "rgb": (166, 82, 44),
      "color": "#a6522c",
      "title": "绀红",
      "Py": "ganhong"
    },
    {
      "CMYK": (31, 79, 77, 37),
      "rgb": (119, 61, 49),
      "color": "#773d31",
      "title": "橡树棕",
      "Py": "xiangshuzong"
    },
    {
      "CMYK": (45, 68, 57, 66),
      "rgb": (72, 51, 50),
      "color": "#483332",
      "title": "海报灰",
      "Py": "haibaohui"
    },
    {
      "CMYK": (41, 76, 64, 65),
      "rgb": (175, 46, 43),
      "color": "#4b2e2b",
      "title": "玫瑰灰",
      "Py": "meiguihui"
    },
    {
      "CMYK": (41, 84, 71, 67),
      "rgb": (72, 37, 34),
      "color": "#482522",
      "title": "火山棕",
      "Py": "huoshanzong"
    },
    {
      "CMYK": (40, 92, 78, 66),
      "rgb": (72, 30, 28),
      "color": "#481e1c",
      "title": "豆沙",
      "Py": "dousha"
    },
    {
      "CMYK": (0, 9, 12, 0),
      "rgb": (251, 238, 226),
      "color": "#fbeee2",
      "title": "淡米粉",
      "Py": "danmifen"
    },
    {
      "CMYK": (0, 19, 19, 0),
      "rgb": (246, 220, 206),
      "color": "#f6dcce",
      "title": "初桃粉红",
      "Py": "chutaofenhong"
    },
    {
      "CMYK": (0, 27, 27, 0),
      "rgb": (247, 207, 186),
      "color": "#f7cfba",
      "title": "介壳淡粉红",
      "Py": "jieqiaodanfenhong"
    },
    {
      "CMYK": (0, 43, 43, 0),
      "rgb": (246, 173, 143),
      "color": "#f6ad8f",
      "title": "淡藏花红",
      "Py": "dancanghuahong"
    },
    {
      "CMYK": (0, 58, 61, 0),
      "rgb": (246, 140, 96),
      "color": "#f68c60",
      "title": "瓜瓤红",
      "Py": "guaranghong"
    },
    {
      "CMYK": (0, 67, 74, 0),
      "rgb": (249, 114, 61),
      "color": "#f9723d",
      "title": "芙蓉红",
      "Py": "furonghong"
    },
    {
      "CMYK": (0, 74, 85, 0),
      "rgb": (250, 93, 25),
      "color": "#fa5d19",
      "title": "莓酱红",
      "Py": "meijianghong"
    },
    {
      "CMYK": (0, 62, 66, 0),
      "rgb": (238, 128, 85),
      "color": "#ee8055",
      "title": "法螺红",
      "Py": "faluohong"
    },
    {
      "CMYK": (4, 82, 99, 0),
      "rgb": (207, 72, 19),
      "color": "#cf4813",
      "title": "落霞红",
      "Py": "luoxiahong"
    },
    {
      "CMYK": (21, 43, 43, 9),
      "rgb": (184, 148, 133),
      "color": "#b89485",
      "title": "淡玫瑰灰",
      "Py": "danmeiguihui"
    },
    {
      "CMYK": (18, 80, 92, 7),
      "rgb": (177, 75, 40),
      "color": "#b14b28",
      "title": "蟹蝥红",
      "Py": "xiemaohong"
    },
    {
      "CMYK": (27, 91, 95, 28),
      "rgb": (134, 48, 32),
      "color": "#863020",
      "title": "火岩棕",
      "Py": "huoyanzong"
    },
    {
      "CMYK": (27, 96, 100, 27),
      "rgb": (134, 38, 23),
      "color": "#862617",
      "title": "赭石",
      "Py": "zheshi"
    },
    {
      "CMYK": (36, 90, 82, 56),
      "rgb": (89, 38, 32),
      "color": "#592620",
      "title": "暗驼棕",
      "Py": "antuozong"
    },
    {
      "CMYK": (35, 96, 88, 55),
      "rgb": (90, 31, 27),
      "color": "#5a1f1b",
      "title": "酱棕",
      "Py": "jiangzong"
    },
    {
      "CMYK": (34, 98, 91, 53),
      "rgb": (92, 30, 25),
      "color": "#5c1e19",
      "title": "栗棕",
      "Py": "lizong"
    },
    {
      "CMYK": (0, 31, 24, 0),
      "rgb": (244, 199, 186),
      "color": "#f4c7ba",
      "title": "洋水仙红",
      "Py": "yangshuixianhong"
    },
    {
      "CMYK": (0, 67, 55, 0),
      "rgb": (241, 118, 102),
      "color": "#f17666",
      "title": "谷鞘红",
      "Py": "guqiaohong"
    },
    {
      "CMYK": (0, 77, 69, 0),
      "rgb": (241, 86, 66),
      "color": "#f15642",
      "title": "苹果红",
      "Py": "pingguohong"
    },
    {
      "CMYK": (0, 84, 82, 0),
      "rgb": (245, 57, 28),
      "color": "#f5391c",
      "title": "铁水红",
      "Py": "tieshuihong"
    },
    {
      "CMYK": (0, 76, 67, 0),
      "rgb": (242, 90, 71),
      "color": "#f25a47",
      "title": "桂红",
      "Py": "guihong"
    },
    {
      "CMYK": (0, 84, 82, 0),
      "rgb": (243, 59, 31),
      "color": "#f33b1f",
      "title": "极光红",
      "Py": "jiguanghong"
    },
    {
      "CMYK": (0, 38, 25, 0),
      "rgb": (242, 185, 178),
      "color": "#f2b9b2",
      "title": "粉红",
      "Py": "fenhong"
    },
    {
      "CMYK": (0, 53, 36, 0),
      "rgb": (241, 151, 144),
      "color": "#f19790",
      "title": "舌红",
      "Py": "shehong"
    },
    {
      "CMYK": (0, 76, 68, 0),
      "rgb": (240, 90, 70),
      "color": "#f05a46",
      "title": "曲红",
      "Py": "quhong"
    },
    {
      "CMYK": (0, 83, 81, 0),
      "rgb": (242, 62, 35),
      "color": "#f23e23",
      "title": "红汞红",
      "Py": "honggonghong"
    },
    {
      "CMYK": (0, 29, 16, 0),
      "rgb": (242, 202, 201),
      "color": "#f2cac9",
      "title": "淡绯",
      "Py": "danfei"
    },
    {
      "CMYK": (0, 43, 24, 0),
      "rgb": (239, 175, 173),
      "color": "#efafad",
      "title": "无花果红",
      "Py": "wuhuaguohong"
    },
    {
      "CMYK": (0, 57, 36, 0),
      "rgb": (241, 144, 140),
      "color": "#f1908c",
      "title": "榴子红",
      "Py": "liuzihong"
    },
    {
      "CMYK": (0, 83, 81, 0),
      "rgb": (240, 63, 36),
      "color": "#f03f24",
      "title": "胭脂红",
      "Py": "yanzhihong"
    },
    {
      "CMYK": (0, 50, 23, 0),
      "rgb": (240, 161, 168),
      "color": "#f0a1a8",
      "title": "合欢红",
      "Py": "hehuanhong"
    },
    {
      "CMYK": (0, 56, 27, 0),
      "rgb": (241, 147, 156),
      "color": "#f1939c",
      "title": "春梅红",
      "Py": "chunmeihong"
    },
    {
      "CMYK": (0, 65, 38, 0),
      "rgb": (240, 124, 130),
      "color": "#f07c82",
      "title": "香叶红",
      "Py": "xiangyehong"
    },
    {
      "CMYK": (0, 80, 72, 0),
      "rgb": (240, 74, 58),
      "color": "#f04a3a",
      "title": "珊瑚红",
      "Py": "shanhuhong"
    },
    {
      "CMYK": (0, 84, 82, 0),
      "rgb": (241, 60, 34),
      "color": "#f13c22",
      "title": "萝卜红",
      "Py": "luobohong"
    },
    {
      "CMYK": (0, 65, 29, 0),
      "rgb": (231, 124, 142),
      "color": "#e77c8e",
      "title": "淡茜红",
      "Py": "danqianhong"
    },
    {
      "CMYK": (0, 77, 49, 0),
      "rgb": (237, 90, 101),
      "color": "#ed5a65",
      "title": "艳红",
      "Py": "yanhong"
    },
    {
      "CMYK": (0, 81, 66, 0),
      "rgb": (237, 72, 69),
      "color": "#ed4845",
      "title": "淡菽红",
      "Py": "danshuhong"
    },
    {
      "CMYK": (0, 84, 76, 0),
      "rgb": (237, 59, 47),
      "color": "#ed3b2f",
      "title": "鱼鳃红",
      "Py": "yusaihong"
    },
    {
      "CMYK": (0, 86, 82, 0),
      "rgb": (237, 51, 33),
      "color": "#ed3321",
      "title": "樱桃红",
      "Py": "yingtaohong"
    },
    {
      "CMYK": (0, 82, 44, 0),
      "rgb": (238, 72, 102),
      "color": "#ee4866",
      "title": "淡蕊香红",
      "Py": "danruixianghong"
    },
    {
      "CMYK": (0, 82, 46, 0),
      "rgb": (238, 72, 99),
      "color": "#ee4863",
      "title": "石竹红",
      "Py": "shizhuhong"
    },
    {
      "CMYK": (0, 82, 50, 0),
      "rgb": (239, 71, 93),
      "color": "#ef475d",
      "title": "草茉莉红",
      "Py": "caomolihong"
    },
    {
      "CMYK": (0, 84, 60, 0),
      "rgb": (238, 63, 77),
      "color": "#ee3f4d",
      "title": "茶花红",
      "Py": "chahuahong"
    },
    {
      "CMYK": (0, 86, 74, 0),
      "rgb": (237, 51, 51),
      "color": "#ed3333",
      "title": "枸枢红",
      "Py": "goushuhong"
    },
    {
      "CMYK": (0, 88, 81, 0),
      "rgb": (236, 43, 36),
      "color": "#ec2b24",
      "title": "秋海棠红",
      "Py": "qiuhaitanghong"
    },
    {
      "CMYK": (0, 89, 84, 0),
      "rgb": (235, 38, 26),
      "color": "#eb261a",
      "title": "丽春红",
      "Py": "lichunhong"
    },
    {
      "CMYK": (0, 90, 90, 0),
      "rgb": (222, 42, 24),
      "color": "#de2a18",
      "title": "夕阳红",
      "Py": "xiyanghong"
    },
    {
      "CMYK": (0, 92, 95, 0),
      "rgb": (212, 37, 23),
      "color": "#d42517",
      "title": "鹤顶红",
      "Py": "hedinghong"
    },
    {
      "CMYK": (19, 89, 85, 9),
      "rgb": (171, 55, 47),
      "color": "#ab372f",
      "title": "鹅血石红",
      "Py": "exueshihong"
    },
    {
      "CMYK": (17, 98, 100, 8),
      "rgb": (172, 31, 24),
      "color": "#ac1f18",
      "title": "覆盆子红",
      "Py": "fupenzihong"
    },
    {
      "CMYK": (36, 81, 64, 54),
      "rgb": (93, 49, 49),
      "color": "#5d3131",
      "title": "貂紫",
      "Py": "diaozi"
    },
    {
      "CMYK": (35, 94, 77, 53),
      "rgb": (92, 34, 35),
      "color": "#5c2223",
      "title": "暗玉紫",
      "Py": "anyuzi"
    },
    {
      "CMYK": (35, 100, 85, 54),
      "rgb": (90, 25, 27),
      "color": "#5a191b",
      "title": "栗紫",
      "Py": "lizi"
    },
    {
      "CMYK": (35, 100, 80, 54),
      "rgb": (90, 18, 22),
      "color": "#5a1216",
      "title": "葡萄酱紫",
      "Py": "putaojiangzi"
    },
    {
      "CMYK": (0, 49, 27, 0),
      "rgb": (238, 162, 164),
      "color": "#eea2a4",
      "title": "牡丹粉红",
      "Py": "mudanfenhong"
    },
    {
      "CMYK": (0, 78, 44, 0),
      "rgb": (237, 85, 106),
      "color": "#ed556a",
      "title": "山茶红",
      "Py": "shanchahong"
    },
    {
      "CMYK": (0, 86, 55, 0),
      "rgb": (240, 55, 82),
      "color": "#f03752",
      "title": "海棠红",
      "Py": "haitanghong"
    },
    {
      "CMYK": (13, 83, 62, 3),
      "rgb": (192, 72, 81),
      "color": "#c04851",
      "title": "玉红",
      "Py": "yuhong"
    },
    {
      "CMYK": (11, 93, 77, 2),
      "rgb": (192, 44, 56),
      "color": "#c02c38",
      "title": "高粱红",
      "Py": "gaolianghong"
    },
    {
      "CMYK": (22, 76, 54, 12),
      "rgb": (167, 83, 90),
      "color": "#a7535a",
      "title": "满江红",
      "Py": "manjianghong"
    },
    {
      "CMYK": (28, 100, 86, 33),
      "rgb": (124, 24, 35),
      "color": "#7c1823",
      "title": "枣红",
      "Py": "zaohong"
    },
    {
      "CMYK": (39, 92, 67, 64),
      "rgb": (76, 31, 36),
      "color": "#4c1f24",
      "title": "葡萄紫",
      "Py": "putaozi"
    },
    {
      "CMYK": (39, 100, 79, 63),
      "rgb": (77, 16, 24),
      "color": "#4d1018",
      "title": "酱紫",
      "Py": "jiangzi"
    },
    {
      "CMYK": (0, 89, 62, 0),
      "rgb": (238, 39, 70),
      "color": "#ee2746",
      "title": "淡曙红",
      "Py": "danshuhong"
    },
    {
      "CMYK": (0, 93, 76, 0),
      "rgb": (222, 28, 49),
      "color": "#de1c31",
      "title": "唐菖蒲红",
      "Py": "tangchangpuhong"
    },
    {
      "CMYK": (1, 95, 82, 0),
      "rgb": (209, 26, 45),
      "color": "#d11a2d",
      "title": "鹅冠红",
      "Py": "eguanhong"
    },
    {
      "CMYK": (13, 76, 50, 2),
      "rgb": (196, 90, 101),
      "color": "#c45a65",
      "title": "莓红",
      "Py": "meihong"
    },
    {
      "CMYK": (10, 96, 82, 2),
      "rgb": (194, 31, 48),
      "color": "#c21f30",
      "title": "枫叶红",
      "Py": "fengyehong"
    },
    {
      "CMYK": (19, 99, 86, 11),
      "rgb": (166, 27, 41),
      "color": "#a61b29",
      "title": "苋菜红",
      "Py": "xiancaihong"
    },
    {
      "CMYK": (29, 73, 51, 28),
      "rgb": (137, 78, 84),
      "color": "#894e54",
      "title": "烟红",
      "Py": "yanhong"
    },
    {
      "CMYK": (27, 98, 79, 30),
      "rgb": (130, 32, 43),
      "color": "#82202b",
      "title": "暗紫苑红",
      "Py": "anziyuanhong"
    },
    {
      "CMYK": (27, 100, 90, 29),
      "rgb": (130, 17, 31),
      "color": "#82111f",
      "title": "殷红",
      "Py": "yanhong"
    },
    {
      "CMYK": (36, 95, 71, 59),
      "rgb": (84, 30, 36),
      "color": "#541e24",
      "title": "猪肝紫",
      "Py": "zhuganzi"
    },
    {
      "CMYK": (38, 100, 81, 61),
      "rgb": (80, 10, 22),
      "color": "#500a16",
      "title": "金鱼紫",
      "Py": "jinyuzi"
    },
    {
      "CMYK": (1, 11, 9, 0),
      "rgb": (248, 235, 230),
      "color": "#f8ebe6",
      "title": "草珠红",
      "Py": "caozhuhong"
    },
    {
      "CMYK": (0, 68, 21, 0),
      "rgb": (236, 118, 150),
      "color": "#ec7696",
      "title": "淡绛红",
      "Py": "danjianghong"
    },
    {
      "CMYK": (0, 86, 30, 0),
      "rgb": (239, 52, 115),
      "color": "#ef3473",
      "title": "品红",
      "Py": "pinhong"
    },
    {
      "CMYK": (0, 69, 22, 0),
      "rgb": (234, 114, 147),
      "color": "#ea7293",
      "title": "凤仙花红",
      "Py": "fengxianhuahong"
    },
    {
      "CMYK": (0, 52, 18, 0),
      "rgb": (236, 155, 173),
      "color": "#ec9bad",
      "title": "粉团花红",
      "Py": "fentuanhuahong"
    },
    {
      "CMYK": (0, 80, 28, 0),
      "rgb": (235, 80, 126),
      "color": "#eb507e",
      "title": "夹竹桃红",
      "Py": "jiazhutaohong"
    },
    {
      "CMYK": (0, 88, 36, 0),
      "rgb": (237, 47, 106),
      "color": "#ed2f6a",
      "title": "榲桲红",
      "Py": "wenpohong"
    },
    {
      "CMYK": (0, 39, 14, 0),
      "rgb": (238, 184, 195),
      "color": "#eeb8c3",
      "title": "姜红",
      "Py": "jianghong"
    },
    {
      "CMYK": (0, 80, 27, 0),
      "rgb": (234, 81, 127),
      "color": "#ea517f",
      "title": "莲瓣红",
      "Py": "lianbanhong"
    },
    {
      "CMYK": (0, 33, 11, 0),
      "rgb": (241, 196, 205),
      "color": "#f1c4cd",
      "title": "水红",
      "Py": "shuihong"
    },
    {
      "CMYK": (0, 60, 18, 0),
      "rgb": (236, 138, 164),
      "color": "#ec8aa4",
      "title": "报春红",
      "Py": "baochunhong"
    },
    {
      "CMYK": (8, 78, 35, 1),
      "rgb": (206, 87, 109),
      "color": "#ce5777",
      "title": "月季红",
      "Py": "yuejihong"
    },
    {
      "CMYK": (0, 52, 15, 0),
      "rgb": (237, 157, 178),
      "color": "#ed9db2",
      "title": "豇豆红",
      "Py": "jiangdouhong"
    },
    {
      "CMYK": (0, 63, 18, 0),
      "rgb": (239, 130, 160),
      "color": "#ef82a0",
      "title": "霞光红",
      "Py": "xiaguanghong"
    },
    {
      "CMYK": (0, 85, 33, 0),
      "rgb": (235, 60, 112),
      "color": "#eb3c70",
      "title": "松叶牡丹红",
      "Py": "songyemudanhong"
    },
    {
      "CMYK": (0, 88, 40, 0),
      "rgb": (236, 44, 100),
      "color": "#ec2c64",
      "title": "喜蛋红",
      "Py": "xidanhong"
    },
    {
      "CMYK": (5, 38, 20, 0),
      "rgb": (227, 180, 184),
      "color": "#e3b4b8",
      "title": "鼠鼻红",
      "Py": "shubihong"
    },
    {
      "CMYK": (5, 96, 73, 1),
      "rgb": (204, 22, 58),
      "color": "#cc163a",
      "title": "尖晶玉红",
      "Py": "jianjingyuhong"
    },
    {
      "CMYK": (16, 61, 34, 4),
      "rgb": (194, 124, 136),
      "color": "#c27c88",
      "title": "山黎豆红",
      "Py": "shanlidouhong"
    },
    {
      "CMYK": (13, 90, 56, 3),
      "rgb": (191, 53, 83),
      "color": "#bf3553",
      "title": "锦葵红",
      "Py": "jinkuihong"
    },
    {
      "CMYK": (41, 64, 44, 36),
      "rgb": (115, 87, 92),
      "color": "#73575c",
      "title": "鼠背灰",
      "Py": "shubeihui"
    },
    {
      "CMYK": (33, 100, 75, 49),
      "rgb": (98, 22, 36),
      "color": "#621624",
      "title": "甘蔗紫",
      "Py": "ganzhezi"
    },
    {
      "CMYK": (32, 100, 84, 49),
      "rgb": (99, 7, 28),
      "color": "#63071c",
      "title": "石竹紫",
      "Py": "shizhuzi"
    },
    {
      "CMYK": (57, 72, 54, 74),
      "rgb": (54, 40, 43),
      "color": "#36282b",
      "title": "苍蝇灰",
      "Py": "cangyinghui"
    },
    {
      "CMYK": (52, 88, 58, 81),
      "rgb": (48, 22, 28),
      "color": "#30161c",
      "title": "卵石紫",
      "Py": "luanshizi"
    },
    {
      "CMYK": (56, 88, 62, 84),
      "rgb": (43, 18, 22),
      "color": "#2b1216",
      "title": "李紫",
      "Py": "lizi"
    },
    {
      "CMYK": (58, 90, 63, 83),
      "rgb": (45, 12, 19),
      "color": "#2d0c13",
      "title": "茄皮紫",
      "Py": "qiepizi"
    },
    {
      "CMYK": (0, 76, 16, 0),
      "rgb": (206, 94, 138),
      "color": "#ce5e8a",
      "title": "吊钟花红",
      "Py": "diaozhonghuahong"
    },
    {
      "CMYK": (0, 81, 18, 0),
      "rgb": (236, 78, 138),
      "color": "#ec4e8a",
      "title": "兔眼红",
      "Py": "tuyanhong"
    },
    {
      "CMYK": (0, 87, 24, 0),
      "rgb": (238, 44, 121),
      "color": "#ee2c79",
      "title": "紫荆红",
      "Py": "zijinghong"
    },
    {
      "CMYK": (24, 99, 52, 19),
      "rgb": (149, 28, 72),
      "color": "#951c48",
      "title": "菜头紫",
      "Py": "caitouzi"
    },
    {
      "CMYK": (34, 97, 54, 50),
      "rgb": (98, 29, 52),
      "color": "#621d34",
      "title": "鹞冠紫",
      "Py": "yaoguanzi"
    },
    {
      "CMYK": (33, 100, 58, 60),
      "rgb": (98, 16, 46),
      "color": "#62102e",
      "title": "葡萄酒红",
      "Py": "putaojiuhong"
    },
    {
      "CMYK": (53, 81, 50, 74),
      "rgb": (56, 33, 41),
      "color": "#382129",
      "title": "磨石紫",
      "Py": "moshizi"
    },
    {
      "CMYK": (48, 90, 50, 76),
      "rgb": (56, 25, 36),
      "color": "#381924",
      "title": "檀紫",
      "Py": "tanzi"
    },
    {
      "CMYK": (50, 91, 54, 79),
      "rgb": (51, 20, 30),
      "color": "#33141e",
      "title": "火鹅紫",
      "Py": "huoezi"
    },
    {
      "CMYK": (53, 92, 55, 81),
      "rgb": (49, 15, 27),
      "color": "#310f1b",
      "title": "墨紫",
      "Py": "mozi"
    },
    {
      "CMYK": (0, 48, 15, 0),
      "rgb": (238, 166, 183),
      "color": "#eea6b7",
      "title": "晶红",
      "Py": "jinghong"
    },
    {
      "CMYK": (0, 82, 16, 0),
      "rgb": (239, 73, 139),
      "color": "#ef498b",
      "title": "扁豆花红",
      "Py": "biandouhuahong"
    },
    {
      "CMYK": (2, 66, 22, 0),
      "rgb": (222, 120, 151),
      "color": "#de7897",
      "title": "白芨红",
      "Py": "baijihong"
    },
    {
      "CMYK": (0, 85, 24, 0),
      "rgb": (222, 63, 124),
      "color": "#de3f7c",
      "title": "嫩菱红",
      "Py": "nenlinghong"
    },
    {
      "CMYK": (5, 87, 30, 1),
      "rgb": (209, 60, 116),
      "color": "#d13c74",
      "title": "菠根红",
      "Py": "bogenhong"
    },
    {
      "CMYK": (15, 68, 28, 2),
      "rgb": (197, 112, 139),
      "color": "#c5708b",
      "title": "酢酱草红",
      "Py": "cujiangcaohong"
    },
    {
      "CMYK": (22, 83, 34, 11),
      "rgb": (168, 69, 107),
      "color": "#a8456b",
      "title": "洋葱紫",
      "Py": "yangcongzi"
    },
    {
      "CMYK": (40, 92, 47, 64),
      "rgb": (75, 30, 47),
      "color": "#4b1e2f",
      "title": "海象紫",
      "Py": "haixiangzi"
    },
    {
      "CMYK": (41, 97, 49, 68),
      "rgb": (70, 22, 41),
      "color": "#461629",
      "title": "绀紫",
      "Py": "ganzi"
    },
    {
      "CMYK": (42, 99, 51, 69),
      "rgb": (68, 14, 37),
      "color": "#440e25",
      "title": "古铜紫",
      "Py": "gutongzi"
    },
    {
      "CMYK": (0, 30, 12, 0),
      "rgb": (240, 201, 207),
      "color": "#f0c9cf",
      "title": "石蕊红",
      "Py": "shiruihong"
    },
    {
      "CMYK": (0, 50, 16, 0),
      "rgb": (235, 160, 179),
      "color": "#eba0b3",
      "title": "芍药耕红",
      "Py": "shaoyaogenghong"
    },
    {
      "CMYK": (0, 88, 23, 0),
      "rgb": (236, 45, 122),
      "color": "#ec2d7a",
      "title": "藏花红",
      "Py": "canghuahong"
    },
    {
      "CMYK": (0, 71, 18, 0),
      "rgb": (225, 108, 150),
      "color": "#e16c96",
      "title": "初荷红",
      "Py": "chuhehong"
    },
    {
      "CMYK": (6, 13, 7, 0),
      "rgb": (237, 227, 231),
      "color": "#ede3e7",
      "title": "马鞭草紫",
      "Py": "mabiancaozi"
    },
    {
      "CMYK": (7, 20, 8, 0),
      "rgb": (233, 215, 223),
      "color": "#e9d7df",
      "title": "丁香淡紫",
      "Py": "dingxiangdanzi"
    },
    {
      "CMYK": (7, 79, 18, 0),
      "rgb": (210, 86, 140),
      "color": "#d2568c",
      "title": "丹紫红",
      "Py": "danzihong"
    },
    {
      "CMYK": (4, 89, 21, 0),
      "rgb": (210, 53, 125),
      "color": "#d2357d",
      "title": "玫瑰红",
      "Py": "meiguihong"
    },
    {
      "CMYK": (19, 27, 9, 0),
      "rgb": (209, 194, 211),
      "color": "#d1c2d3",
      "title": "淡牵牛紫",
      "Py": "danqianniuzi"
    },
    {
      "CMYK": (21, 37, 12, 0),
      "rgb": (200, 173, 196),
      "color": "#c8adc4",
      "title": "凤信紫",
      "Py": "fengxinzi"
    },
    {
      "CMYK": (23, 53, 14, 1),
      "rgb": (192, 142, 175),
      "color": "#c08eaf",
      "title": "萝兰紫",
      "Py": "luolanzi"
    },
    {
      "CMYK": (18, 91, 18, 2),
      "rgb": (186, 47, 123),
      "color": "#ba2f7b",
      "title": "玫瑰紫",
      "Py": "meiguizi"
    },
    {
      "CMYK": (58, 56, 17, 2),
      "rgb": (128, 118, 163),
      "color": "#8076a3",
      "title": "藤萝紫",
      "Py": "tengluozi"
    },
    {
      "CMYK": (34, 39, 0, 24),
      "rgb": (128, 118, 195),
      "color": "#8076c3",
      "title": "槿紫",
      "Py": "jinzi"
    },
    {
      "CMYK": (56, 72, 15, 1),
      "rgb": (129, 92, 148),
      "color": "#815c94",
      "title": "蕈紫",
      "Py": "xunzi"
    },
    {
      "CMYK": (54, 89, 12, 1),
      "rgb": (129, 60, 133),
      "color": "#813c85",
      "title": "桔梗紫",
      "Py": "jiegengzi"
    },
    {
      "CMYK": (52, 100, 17, 7),
      "rgb": (126, 22, 113),
      "color": "#7e1671",
      "title": "魏紫",
      "Py": "weizi"
    },
    {
      "CMYK": (3, 26, 10, 0),
      "rgb": (233, 204, 211),
      "color": "#e9ccd3",
      "title": "芝兰紫",
      "Py": "zhilanzi"
    },
    {
      "CMYK": (10, 67, 12, 0),
      "rgb": (210, 118, 163),
      "color": "#d276a3",
      "title": "菱锰红",
      "Py": "lingmenghong"
    },
    {
      "CMYK": (11, 97, 10, 0),
      "rgb": (204, 85, 149),
      "color": "#cc5595",
      "title": "龙须红",
      "Py": "longxuhong"
    },
    {
      "CMYK": (8, 22, 12, 0),
      "rgb": (230, 210, 213),
      "color": "#e6d2d5",
      "title": "蓟粉红",
      "Py": "jifenhong"
    },
    {
      "CMYK": (16, 79, 14, 1),
      "rgb": (195, 86, 145),
      "color": "#c35691",
      "title": "电气石红",
      "Py": "dianqishihong"
    },
    {
      "CMYK": (19, 68, 18, 1),
      "rgb": (192, 111, 152),
      "color": "#c06f98",
      "title": "樱草紫",
      "Py": "yingcaozi"
    },
    {
      "CMYK": (25, 31, 26, 5),
      "rgb": (189, 174, 173),
      "color": "#bdaead",
      "title": "芦穗灰",
      "Py": "lusuihui"
    },
    {
      "CMYK": (26, 43, 26, 6),
      "rgb": (181, 152, 161),
      "color": "#b598a1",
      "title": "隐红灰",
      "Py": "yinhonghui"
    },
    {
      "CMYK": (27, 97, 27, 14),
      "rgb": (155, 30, 100),
      "color": "#9b1e64",
      "title": "苋菜紫",
      "Py": "xiancaizi"
    },
    {
      "CMYK": (39, 53, 38, 25),
      "rgb": (133, 109, 114),
      "color": "#856d72",
      "title": "芦灰",
      "Py": "luhui"
    },
    {
      "CMYK": (49, 71, 49, 58),
      "rgb": (79, 56, 62),
      "color": "#4f383e",
      "title": "暮云灰",
      "Py": "muyunhui"
    },
    {
      "CMYK": (49, 82, 46, 63),
      "rgb": (72, 41, 54),
      "color": "#482936",
      "title": "斑鸠灰",
      "Py": "banjiuhui"
    },
    {
      "CMYK": (4, 11, 9, 0),
      "rgb": (242, 231, 229),
      "color": "#f2e7e5",
      "title": "淡藤萝紫",
      "Py": "dantengluozi"
    },
    {
      "CMYK": (10, 27, 11, 0),
      "rgb": (224, 200, 209),
      "color": "#e0c8d1",
      "title": "淡青紫",
      "Py": "danqingzi"
    },
    {
      "CMYK": (24, 58, 15, 1),
      "rgb": (188, 132, 168),
      "color": "#bc84a8",
      "title": "青蛤壳紫",
      "Py": "qinghakezi"
    },
    {
      "CMYK": (31, 71, 15, 1),
      "rgb": (173, 101, 152),
      "color": "#ad6598",
      "title": "豆蔻紫",
      "Py": "doukouzi"
    },
    {
      "CMYK": (35, 75, 18, 2),
      "rgb": (163, 92, 143),
      "color": "#a35c8f",
      "title": "扁豆紫",
      "Py": "biandouzi"
    },
    {
      "CMYK": (39, 91, 15, 3),
      "rgb": (152, 54, 128),
      "color": "#983680",
      "title": "芥花紫",
      "Py": "jiehuazi"
    },
    {
      "CMYK": (43, 97, 19, 8),
      "rgb": (139, 38, 113),
      "color": "#8b2671",
      "title": "青莲",
      "Py": "qinglian"
    },
    {
      "CMYK": (44, 85, 24, 10),
      "rgb": (137, 66, 118),
      "color": "#894276",
      "title": "芓紫",
      "Py": "zizi"
    },
    {
      "CMYK": (45, 99, 24, 16),
      "rgb": (126, 32, 101),
      "color": "#7e2065",
      "title": "葛巾紫",
      "Py": "gejinzi"
    },
    {
      "CMYK": (49, 100, 29, 32),
      "rgb": (104, 23, 82),
      "color": "#681752",
      "title": "牵牛紫",
      "Py": "qianniuzi"
    },
    {
      "CMYK": (53, 75, 41, 41),
      "rgb": (93, 63, 81),
      "color": "#5d3f51",
      "title": "紫灰",
      "Py": "zihui"
    },
    {
      "CMYK": (55, 87, 41, 52),
      "rgb": (78, 42, 64),
      "color": "#4e2a40",
      "title": "龙睛鱼紫",
      "Py": "longjingyuzi"
    },
    {
      "CMYK": (58, 96, 40, 61),
      "rgb": (65, 28, 53),
      "color": "#411c35",
      "title": "荸荠紫",
      "Py": "biqizi"
    },
    {
      "CMYK": (63, 74, 52, 70),
      "rgb": (54, 41, 47),
      "color": "#36292f",
      "title": "古鼎灰",
      "Py": "gudinghui"
    },
    {
      "CMYK": (81, 87, 54, 84),
      "rgb": (30, 19, 29),
      "color": "#1e131d",
      "title": "乌梅紫",
      "Py": "wumeizi"
    },
    {
      "CMYK": (83, 87, 55, 86),
      "rgb": (28, 13, 26),
      "color": "#1c0d1a",
      "title": "深牵牛紫",
      "Py": "shenqianniuzi"
    },
    {
      "CMYK": (7, 5, 7, 0),
      "rgb": (241, 240, 237),
      "color": "#f1f0ed",
      "title": "银白",
      "Py": "yinbai"
    },
    {
      "CMYK": (13, 10, 9, 0),
      "rgb": (226, 225, 228),
      "color": "#e2e1e4",
      "title": "芡食白",
      "Py": "qianshibai"
    },
    {
      "CMYK": (23, 18, 12, 1),
      "rgb": (204, 204, 214),
      "color": "#ccccd6",
      "title": "远山紫",
      "Py": "yuanshanzi"
    },
    {
      "CMYK": (39, 31, 17, 2),
      "rgb": (167, 168, 189),
      "color": "#a7a8bd",
      "title": "淡蓝紫",
      "Py": "danlanzi"
    },
    {
      "CMYK": (74, 64, 14, 1),
      "rgb": (97, 100, 159),
      "color": "#61649f",
      "title": "山梗紫",
      "Py": "shangengzi"
    },
    {
      "CMYK": (63, 53, 22, 5),
      "rgb": (116, 117, 155),
      "color": "#74759b",
      "title": "螺甸紫",
      "Py": "luodianzi"
    },
    {
      "CMYK": (21, 17, 19, 1),
      "rgb": (207, 204, 201),
      "color": "#cfccc9",
      "title": "玛瑙灰",
      "Py": "manaohui"
    },
    {
      "CMYK": (80, 73, 21, 6),
      "rgb": (82, 82, 136),
      "color": "#525288",
      "title": "野菊紫",
      "Py": "yejuzi"
    },
    {
      "CMYK": (100, 93, 21, 5),
      "rgb": (46, 49, 124),
      "color": "#2e317c",
      "title": "满天星紫",
      "Py": "mantianxingzi"
    },
    {
      "CMYK": (48, 45, 40, 26),
      "rgb": (122, 115, 116),
      "color": "#7a7374",
      "title": "锌灰",
      "Py": "xinhui"
    },
    {
      "CMYK": (91, 84, 40, 43),
      "rgb": (48, 47, 75),
      "color": "#302f4b",
      "title": "野葡萄紫",
      "Py": "yeputaozi"
    },
    {
      "CMYK": (70, 69, 49, 56),
      "rgb": (62, 56, 65),
      "color": "#3e3841",
      "title": "剑锋紫",
      "Py": "jianfengzi"
    },
    {
      "CMYK": (79, 74, 49, 60),
      "rgb": (50, 47, 59),
      "color": "#322f3b",
      "title": "龙葵紫",
      "Py": "longkuizi"
    },
    {
      "CMYK": (90, 84, 50, 69),
      "rgb": (34, 32, 46),
      "color": "#22202e",
      "title": "暗龙胆紫",
      "Py": "anlongdanzi"
    },
    {
      "CMYK": (98, 93, 48, 73),
      "rgb": (31, 32, 64),
      "color": "#1f2040",
      "title": "晶石紫",
      "Py": "jingshizi"
    },
    {
      "CMYK": (100, 94, 52, 77),
      "rgb": (19, 17, 36),
      "color": "#131124",
      "title": "暗蓝紫",
      "Py": "anlanzi"
    },
    {
      "CMYK": (95, 46, 10, 1),
      "rgb": (39, 117, 182),
      "color": "#2775b6",
      "title": "景泰蓝",
      "Py": "jingtailan"
    },
    {
      "CMYK": (96, 47, 11, 1),
      "rgb": (36, 116, 181),
      "color": "#2474b5",
      "title": "尼罗蓝",
      "Py": "niluolan"
    },
    {
      "CMYK": (25, 6, 10, 0),
      "rgb": (208, 223, 230),
      "color": "#d0dfe6",
      "title": "远天蓝",
      "Py": "yuantianlan"
    },
    {
      "CMYK": (53, 19, 15, 1),
      "rgb": (147, 181, 207),
      "color": "#93b5cf",
      "title": "星蓝",
      "Py": "xinglan"
    },
    {
      "CMYK": (74, 27, 16, 2),
      "rgb": (97, 154, 195),
      "color": "#619ac3",
      "title": "羽扇豆蓝",
      "Py": "yushandoulan"
    },
    {
      "CMYK": (95, 45, 10, 1),
      "rgb": (35, 118, 183),
      "color": "#2376b7",
      "title": "花青",
      "Py": "huaqing"
    },
    {
      "CMYK": (78, 27, 17, 2),
      "rgb": (86, 152, 195),
      "color": "#5698c3",
      "title": "睛蓝",
      "Py": "jinglan"
    },
    {
      "CMYK": (99, 44, 10, 1),
      "rgb": (33, 119, 184),
      "color": "#2177b8",
      "title": "虹蓝",
      "Py": "honglan"
    },
    {
      "CMYK": (43, 4, 16, 0),
      "rgb": (176, 213, 223),
      "color": "#b0d5df",
      "title": "湖水蓝",
      "Py": "hushuilan"
    },
    {
      "CMYK": (59, 12, 19, 0),
      "rgb": (138, 188, 209),
      "color": "#8abcd1",
      "title": "秋波蓝",
      "Py": "qiubolan"
    },
    {
      "CMYK": (73, 17, 20, 1),
      "rgb": (102, 169, 201),
      "color": "#66a9c9",
      "title": "涧石蓝",
      "Py": "jianshilan"
    },
    {
      "CMYK": (93, 36, 15, 2),
      "rgb": (41, 131, 187),
      "color": "#2983bb",
      "title": "潮蓝",
      "Py": "chaolan"
    },
    {
      "CMYK": (99, 48, 11, 1),
      "rgb": (23, 114, 180),
      "color": "#1772b4",
      "title": "群青",
      "Py": "qunqing"
    },
    {
      "CMYK": (74, 2, 24, 0),
      "rgb": (99, 187, 208),
      "color": "#63bbd0",
      "title": "霁青",
      "Py": "jiqing"
    },
    {
      "CMYK": (77, 7, 24, 0),
      "rgb": (92, 179, 204),
      "color": "#5cb3cc",
      "title": "碧青",
      "Py": "biqing"
    },
    {
      "CMYK": (94, 32, 17, 3),
      "rgb": (36, 134, 185),
      "color": "#2486b9",
      "title": "宝石蓝",
      "Py": "baoshilan"
    },
    {
      "CMYK": (98, 43, 14, 2),
      "rgb": (22, 119, 179),
      "color": "#1677b3",
      "title": "天蓝",
      "Py": "tianlan"
    },
    {
      "CMYK": (100, 52, 11, 1),
      "rgb": (18, 107, 174),
      "color": "#126bae",
      "title": "柏林蓝",
      "Py": "bolinlan"
    },
    {
      "CMYK": (92, 10, 25, 1),
      "rgb": (34, 162, 195),
      "color": "#22a2c3",
      "title": "海青",
      "Py": "haiqing"
    },
    {
      "CMYK": (94, 16, 23, 3),
      "rgb": (26, 148, 188),
      "color": "#1a94bc",
      "title": "钴蓝",
      "Py": "gulan"
    },
    {
      "CMYK": (95, 25, 20, 4),
      "rgb": (21, 139, 184),
      "color": "#158bb8",
      "title": "鸢尾蓝",
      "Py": "yuanweilan"
    },
    {
      "CMYK": (98, 42, 16, 3),
      "rgb": (17, 119, 176),
      "color": "#1177b0",
      "title": "牵牛花蓝",
      "Py": "qianniuhualan"
    },
    {
      "CMYK": (100, 65, 11, 1),
      "rgb": (15, 89, 164),
      "color": "#0f59a4",
      "title": "飞燕草蓝",
      "Py": "feiyancaolan"
    },
    {
      "CMYK": (95, 47, 14, 2),
      "rgb": (43, 115, 175),
      "color": "#2b73af",
      "title": "品蓝",
      "Py": "pinlan"
    },
    {
      "CMYK": (24, 14, 16, 1),
      "rgb": (205, 209, 211),
      "color": "#cdd1d3",
      "title": "银鱼白",
      "Py": "yinyubai"
    },
    {
      "CMYK": (93, 49, 17, 3),
      "rgb": (49, 112, 167),
      "color": "#3170a7",
      "title": "安安蓝",
      "Py": "ananlan"
    },
    {
      "CMYK": (64, 52, 39, 28),
      "rgb": (94, 97, 109),
      "color": "#5e616d",
      "title": "鱼尾灰",
      "Py": "yuweihui"
    },
    {
      "CMYK": (78, 60, 40, 31),
      "rgb": (71, 81, 100),
      "color": "#475164",
      "title": "鲸鱼灰",
      "Py": "jingyuhui"
    },
    {
      "CMYK": (69, 64, 52, 59),
      "rgb": (255, 254, 250),
      "color": "#fffefa",
      "title": "海参灰",
      "Py": "haishenhui"
    },
    {
      "CMYK": (76, 70, 51, 60),
      "rgb": (53, 51, 60),
      "color": "#35333c",
      "title": "沙鱼灰",
      "Py": "shayuhui"
    },
    {
      "CMYK": (100, 89, 54, 79),
      "rgb": (15, 20, 35),
      "color": "#0f1423",
      "title": "钢蓝",
      "Py": "ganglan"
    },
    {
      "CMYK": (35, 13, 13, 0),
      "rgb": (186, 204, 217),
      "color": "#baccd9",
      "title": "云水蓝",
      "Py": "yunshuilan"
    },
    {
      "CMYK": (55, 20, 18, 1),
      "rgb": (143, 178, 201),
      "color": "#8fb2c9",
      "title": "晴山蓝",
      "Py": "qingshanlan"
    },
    {
      "CMYK": (100, 60, 8, 1),
      "rgb": (22, 97, 171),
      "color": "#1661ab",
      "title": "靛青",
      "Py": "dianqing"
    },
    {
      "CMYK": (29, 16, 17, 1),
      "rgb": (196, 203, 207),
      "color": "#c4cbcf",
      "title": "大理石灰",
      "Py": "dalishihui"
    },
    {
      "CMYK": (100, 67, 16, 3),
      "rgb": (21, 85, 154),
      "color": "#15559a",
      "title": "海涛蓝",
      "Py": "haitaolan"
    },
    {
      "CMYK": (81, 41, 24, 8),
      "rgb": (78, 124, 161),
      "color": "#4e7ca1",
      "title": "蝶翅蓝",
      "Py": "diechilan"
    },
    {
      "CMYK": (93, 50, 21, 6),
      "rgb": (52, 108, 156),
      "color": "#346c9c",
      "title": "海军蓝",
      "Py": "haijunlan"
    },
    {
      "CMYK": (77, 68, 54, 66),
      "rgb": (47, 47, 53),
      "color": "#2f2f35",
      "title": "水牛灰",
      "Py": "shuiniuhui"
    },
    {
      "CMYK": (80, 70, 53, 65),
      "rgb": (45, 46, 54),
      "color": "#2d2e36",
      "title": "牛角灰",
      "Py": "niujiaohui"
    },
    {
      "CMYK": (100, 86, 54, 78),
      "rgb": (19, 24, 36),
      "color": "#131824",
      "title": "燕颔蓝",
      "Py": "yanhanlan"
    },
    {
      "CMYK": (21, 6, 10, 0),
      "rgb": (216, 227, 231),
      "color": "#d8e3e7",
      "title": "云峰白",
      "Py": "yunfengbai"
    },
    {
      "CMYK": (32, 8, 13, 0),
      "rgb": (195, 215, 223),
      "color": "#c3d7df",
      "title": "井天蓝",
      "Py": "jingtianlan"
    },
    {
      "CMYK": (91, 24, 22, 4),
      "rgb": (47, 144, 185),
      "color": "#2f90b9",
      "title": "云山蓝",
      "Py": "yunshanlan"
    },
    {
      "CMYK": (96, 34, 18, 4),
      "rgb": (23, 129, 181),
      "color": "#1781b5",
      "title": "釉蓝",
      "Py": "youlan"
    },
    {
      "CMYK": (28, 12, 17, 0),
      "rgb": (199, 210, 212),
      "color": "#c7d2d4",
      "title": "鸥蓝",
      "Py": "oulan"
    },
    {
      "CMYK": (100, 53, 21, 6),
      "rgb": (17, 101, 154),
      "color": "#11659a",
      "title": "搪磁蓝",
      "Py": "tangcilan"
    },
    {
      "CMYK": (29, 18, 21, 2),
      "rgb": (192, 196, 195),
      "color": "#c0c4c3",
      "title": "月影白",
      "Py": "yueyingbai"
    },
    {
      "CMYK": (36, 20, 23, 2),
      "rgb": (178, 187, 190),
      "color": "#b2bbbe",
      "title": "星灰",
      "Py": "xinghui"
    },
    {
      "CMYK": (70, 38, 36, 18),
      "rgb": (94, 121, 135),
      "color": "#5e7987",
      "title": "淡蓝灰",
      "Py": "danlanhui"
    },
    {
      "CMYK": (100, 68, 32, 20),
      "rgb": (20, 74, 116),
      "color": "#144a74",
      "title": "鷃蓝",
      "Py": "yanlan"
    },
    {
      "CMYK": (55, 40, 40, 23),
      "rgb": (116, 120, 122),
      "color": "#74787a",
      "title": "嫩灰",
      "Py": "nenhui"
    },
    {
      "CMYK": (77, 50, 41, 31),
      "rgb": (73, 92, 105),
      "color": "#495c69",
      "title": "战舰灰",
      "Py": "zhanjianhui"
    },
    {
      "CMYK": (67, 57, 49, 49),
      "rgb": (71, 72, 76),
      "color": "#47484c",
      "title": "瓦罐灰",
      "Py": "waguanhui"
    },
    {
      "CMYK": (87, 69, 51, 58),
      "rgb": (43, 51, 62),
      "color": "#2b333e",
      "title": "青灰",
      "Py": "qinghui"
    },
    {
      "CMYK": (100, 77, 50, 62),
      "rgb": (28, 41, 56),
      "color": "#1c2938",
      "title": "鸽蓝",
      "Py": "gelan"
    },
    {
      "CMYK": (100, 82, 51, 64),
      "rgb": (20, 35, 52),
      "color": "#142334",
      "title": "钢青",
      "Py": "gangqing"
    },
    {
      "CMYK": (100, 84, 51, 68),
      "rgb": (16, 31, 48),
      "color": "#101f30",
      "title": "暗蓝",
      "Py": "anlan"
    },
    {
      "CMYK": (11, 0, 8, 0),
      "rgb": (238, 247, 242),
      "color": "#eef7f2",
      "title": "月白",
      "Py": "yuebai"
    },
    {
      "CMYK": (33, 0, 14, 0),
      "rgb": (198, 230, 232),
      "color": "#c6e6e8",
      "title": "海天蓝",
      "Py": "haitianlan"
    },
    {
      "CMYK": (57, 0, 22, 0),
      "rgb": (147, 213, 220),
      "color": "#93d5dc",
      "title": "清水蓝",
      "Py": "qingshuilan"
    },
    {
      "CMYK": (79, 0, 27, 0),
      "rgb": (81, 196, 211),
      "color": "#51c4d3",
      "title": "瀑布蓝",
      "Py": "pubulan"
    },
    {
      "CMYK": (89, 0, 29, 0),
      "rgb": (41, 183, 203),
      "color": "#29b7cb",
      "title": "蔚蓝",
      "Py": "weilan"
    },
    {
      "CMYK": (92, 0, 28, 0),
      "rgb": (14, 176, 201),
      "color": "#0eb0c9",
      "title": "孔雀蓝",
      "Py": "kongquelan"
    },
    {
      "CMYK": (93, 0, 31, 0),
      "rgb": (16, 174, 194),
      "color": "#10aec2",
      "title": "甸子蓝",
      "Py": "dianzilan"
    },
    {
      "CMYK": (78, 36, 0, 0),
      "rgb": (87, 195, 194),
      "color": "#57c3c2",
      "title": "石绿",
      "Py": "shilv"
    },
    {
      "CMYK": (40, 0, 30, 0),
      "rgb": (185, 222, 201),
      "color": "#b9dec9",
      "title": "竹篁绿",
      "Py": "zhuhuanglv"
    },
    {
      "CMYK": (64, 0, 46, 0),
      "rgb": (131, 203, 172),
      "color": "#83cbac",
      "title": "粉绿",
      "Py": "fenlv"
    },
    {
      "CMYK": (95, 0, 52, 0),
      "rgb": (18, 170, 156),
      "color": "#12aa9c",
      "title": "美蝶绿",
      "Py": "meidielv"
    },
    {
      "CMYK": (75, 0, 61, 0),
      "rgb": (102, 193, 140),
      "color": "#66c18c",
      "title": "毛绿",
      "Py": "maolv"
    },
    {
      "CMYK": (78, 0, 62, 0),
      "rgb": (93, 190, 138),
      "color": "#5dbe8a",
      "title": "蔻梢绿",
      "Py": "koushaolv"
    },
    {
      "CMYK": (81, 0, 62, 0),
      "rgb": (85, 187, 138),
      "color": "#55bb8a",
      "title": "麦苗绿",
      "Py": "maimiaolv"
    },
    {
      "CMYK": (86, 0, 63, 0),
      "rgb": (69, 183, 135),
      "color": "#45b787",
      "title": "蛙绿",
      "Py": "walv"
    },
    {
      "CMYK": (92, 0, 64, 0),
      "rgb": (43, 174, 133),
      "color": "#2bae85",
      "title": "铜绿",
      "Py": "tonglv"
    },
    {
      "CMYK": (96, 0, 64, 0),
      "rgb": (27, 167, 132),
      "color": "#1ba784",
      "title": "竹绿",
      "Py": "zhulv"
    },
    {
      "CMYK": (98, 2, 64, 0),
      "rgb": (18, 161, 130),
      "color": "#12a182",
      "title": "蓝绿",
      "Py": "lanlv"
    },
    {
      "CMYK": (32, 7, 18, 0),
      "rgb": (196, 215, 214),
      "color": "#c4d7d6",
      "title": "穹灰",
      "Py": "qionghui"
    },
    {
      "CMYK": (94, 11, 33, 1),
      "rgb": (30, 158, 179),
      "color": "#1e9eb3",
      "title": "翠蓝",
      "Py": "cuilan"
    },
    {
      "CMYK": (96, 16, 31, 3),
      "rgb": (15, 149, 176),
      "color": "#0f95b0",
      "title": "胆矾蓝",
      "Py": "danfanlan"
    },
    {
      "CMYK": (96, 18, 34, 4),
      "rgb": (20, 145, 168),
      "color": "#1491a8",
      "title": "樫鸟蓝",
      "Py": "jianniaolan"
    },
    {
      "CMYK": (64, 18, 32, 2),
      "rgb": (124, 171, 177),
      "color": "#7cabb1",
      "title": "闪蓝",
      "Py": "shanlan"
    },
    {
      "CMYK": (40, 24, 32, 6),
      "rgb": (164, 172, 167),
      "color": "#a4aca7",
      "title": "冰山蓝",
      "Py": "bingshanlan"
    },
    {
      "CMYK": (56, 26, 36, 7),
      "rgb": (134, 157, 157),
      "color": "#869d9d",
      "title": "虾壳青",
      "Py": "xiakeqing"
    },
    {
      "CMYK": (71, 28, 39, 10),
      "rgb": (100, 142, 147),
      "color": "#648e93",
      "title": "晚波蓝",
      "Py": "wanbolan"
    },
    {
      "CMYK": (89, 27, 41, 13),
      "rgb": (59, 129, 140),
      "color": "#3b818c",
      "title": "蜻蜓蓝",
      "Py": "qingtinglan"
    },
    {
      "CMYK": (99, 33, 38, 21),
      "rgb": (18, 110, 130),
      "color": "#126e82",
      "title": "玉鈫蓝",
      "Py": "yuqinlan"
    },
    {
      "CMYK": (57, 37, 42, 21),
      "rgb": (115, 124, 123),
      "color": "#737c7b",
      "title": "垩灰",
      "Py": "ehui"
    },
    {
      "CMYK": (65, 40, 44, 26),
      "rgb": (97, 113, 114),
      "color": "#617172",
      "title": "夏云灰",
      "Py": "xiayunhui"
    },
    {
      "CMYK": (100, 52, 46, 43),
      "rgb": (19, 72, 87),
      "color": "#134857",
      "title": "苍蓝",
      "Py": "canglan"
    },
    {
      "CMYK": (67, 53, 51, 50),
      "rgb": (71, 75, 76),
      "color": "#474b4c",
      "title": "黄昏灰",
      "Py": "huanghunhui"
    },
    {
      "CMYK": (94, 58, 54, 60),
      "rgb": (33, 55, 61),
      "color": "#21373d",
      "title": "灰蓝",
      "Py": "huilan"
    },
    {
      "CMYK": (100, 64, 56, 68),
      "rgb": (19, 44, 51),
      "color": "#132c33",
      "title": "深灰蓝",
      "Py": "shenhuilan"
    },
    {
      "CMYK": (49, 5, 37, 0),
      "rgb": (164, 202, 182),
      "color": "#a4cab6",
      "title": "玉簪绿",
      "Py": "yuzanlv"
    },
    {
      "CMYK": (96, 12, 66, 2),
      "rgb": (44, 150, 120),
      "color": "#2c9678",
      "title": "青矾绿",
      "Py": "qingfanlv"
    },
    {
      "CMYK": (52, 11, 37, 0),
      "rgb": (154, 190, 175),
      "color": "#9abeaf",
      "title": "草原远绿",
      "Py": "caoyuanyuanlv"
    },
    {
      "CMYK": (74, 14, 51, 1),
      "rgb": (105, 167, 148),
      "color": "#69a794",
      "title": "梧枝绿",
      "Py": "wuzhilv"
    },
    {
      "CMYK": (55, 16, 40, 1),
      "rgb": (146, 179, 165),
      "color": "#92b3a5",
      "title": "浪花绿",
      "Py": "langhualv"
    },
    {
      "CMYK": (99, 23, 70, 10),
      "rgb": (36, 128, 103),
      "color": "#248067",
      "title": "海王绿",
      "Py": "haiwanglv"
    },
    {
      "CMYK": (88, 24, 61, 9),
      "rgb": (66, 134, 117),
      "color": "#428675",
      "title": "亚丁绿",
      "Py": "yadinglv"
    },
    {
      "CMYK": (40, 27, 36, 8),
      "rgb": (159, 163, 154),
      "color": "#9fa39a",
      "title": "镍灰",
      "Py": "niehui"
    },
    {
      "CMYK": (52, 28, 42, 10),
      "rgb": (138, 152, 142),
      "color": "#8a988e",
      "title": "明灰",
      "Py": "minghui"
    },
    {
      "CMYK": (63, 31, 50, 14),
      "rgb": (112, 136, 125),
      "color": "#70887d",
      "title": "淡绿灰",
      "Py": "danlvhui"
    },
    {
      "CMYK": (82, 32, 60, 20),
      "rgb": (73, 117, 104),
      "color": "#497568",
      "title": "飞泉绿",
      "Py": "feiquanlv"
    },
    {
      "CMYK": (62, 43, 52, 34),
      "rgb": (93, 101, 95),
      "color": "#5d655f",
      "title": "狼烟灰",
      "Py": "langyanhui"
    },
    {
      "CMYK": (85, 44, 64, 52),
      "rgb": (49, 74, 67),
      "color": "#314a43",
      "title": "绿灰",
      "Py": "lvhui"
    },
    {
      "CMYK": (93, 46, 70, 61),
      "rgb": (34, 62, 54),
      "color": "#223e36",
      "title": "苍绿",
      "Py": "canglv"
    },
    {
      "CMYK": (98, 46, 73, 63),
      "rgb": (26, 59, 50),
      "color": "#1a3b32",
      "title": "深海绿",
      "Py": "shenhailv"
    },
    {
      "CMYK": (67, 60, 57, 68),
      "rgb": (54, 52, 51),
      "color": "#363433",
      "title": "长石灰",
      "Py": "changshihui"
    },
    {
      "CMYK": (82, 60, 65, 80),
      "rgb": (31, 38, 35),
      "color": "#1f2623",
      "title": "苷蓝绿",
      "Py": "ganlanlv"
    },
    {
      "CMYK": (90, 62, 67, 86),
      "rgb": (20, 30, 27),
      "color": "#141e1b",
      "title": "莽丛绿",
      "Py": "mangconglv"
    },
    {
      "CMYK": (33, 1, 29, 0),
      "rgb": (198, 223, 200),
      "color": "#c6dfc8",
      "title": "淡翠绿",
      "Py": "dancuilv"
    },
    {
      "CMYK": (53, 1, 44, 0),
      "rgb": (158, 204, 171),
      "color": "#9eccab",
      "title": "明绿",
      "Py": "minglv"
    },
    {
      "CMYK": (75, 0, 59, 0),
      "rgb": (104, 184, 142),
      "color": "#68b88e",
      "title": "田园绿",
      "Py": "tianyuanlv"
    },
    {
      "CMYK": (98, 0, 82, 0),
      "rgb": (32, 161, 98),
      "color": "#20a162",
      "title": "翠绿",
      "Py": "cuilv"
    },
    {
      "CMYK": (78, 6, 62, 0),
      "rgb": (97, 172, 133),
      "color": "#61ac85",
      "title": "淡绿",
      "Py": "danlv"
    },
    {
      "CMYK": (90, 7, 73, 0),
      "rgb": (64, 160, 112),
      "color": "#40a070",
      "title": "葱绿",
      "Py": "conglv"
    },
    {
      "CMYK": (99, 10, 91, 2),
      "rgb": (34, 148, 83),
      "color": "#229453",
      "title": "孔雀绿",
      "Py": "kongquelv"
    },
    {
      "CMYK": (27, 11, 27, 1),
      "rgb": (202, 211, 195),
      "color": "#cad3c3",
      "title": "艾绿",
      "Py": "ailv"
    },
    {
      "CMYK": (92, 14, 76, 2),
      "rgb": (60, 149, 102),
      "color": "#3c9566",
      "title": "蟾绿",
      "Py": "chanlv"
    },
    {
      "CMYK": (100, 17, 92, 5),
      "rgb": (32, 137, 77),
      "color": "#20894d",
      "title": "宫殿绿",
      "Py": "gongdianlv"
    },
    {
      "CMYK": (61, 19, 52, 3),
      "rgb": (131, 167, 141),
      "color": "#83a78d",
      "title": "松霜绿",
      "Py": "songshuanglv"
    },
    {
      "CMYK": (81, 19, 67, 4),
      "rgb": (87, 149, 114),
      "color": "#579572",
      "title": "蛋白石绿",
      "Py": "danbaishilv"
    },
    {
      "CMYK": (100, 22, 90, 10),
      "rgb": (32, 127, 76),
      "color": "#207f4c",
      "title": "薄荷绿",
      "Py": "bohelv"
    },
    {
      "CMYK": (66, 29, 58, 12),
      "rgb": (110, 139, 116),
      "color": "#6e8b74",
      "title": "瓦松绿",
      "Py": "wasonglv"
    },
    {
      "CMYK": (100, 31, 91, 25),
      "rgb": (26, 104, 64),
      "color": "#1a6840",
      "title": "荷叶绿",
      "Py": "heyelv"
    },
    {
      "CMYK": (62, 42, 56, 34),
      "rgb": (94, 102, 91),
      "color": "#5e665b",
      "title": "田螺绿",
      "Py": "tianluolv"
    },
    {
      "CMYK": (74, 42, 65, 40),
      "rgb": (72, 91, 77),
      "color": "#485b4d",
      "title": "白屈菜绿",
      "Py": "baiqucailv"
    },
    {
      "CMYK": (64, 57, 60, 67),
      "rgb": (57, 55, 51),
      "color": "#393733",
      "title": "河豚灰",
      "Py": "hetunhui"
    },
    {
      "CMYK": (68, 56, 60, 66),
      "rgb": (55, 56, 52),
      "color": "#373834",
      "title": "蒽油绿",
      "Py": "enyoulv"
    },
    {
      "CMYK": (76, 56, 75, 72),
      "rgb": (43, 49, 44),
      "color": "#2b312c",
      "title": "槲寄生绿",
      "Py": "hujishenglv"
    },
    {
      "CMYK": (91, 60, 76, 83),
      "rgb": (21, 35, 27),
      "color": "#15231b",
      "title": "云杉绿",
      "Py": "yunshanlv"
    },
    {
      "CMYK": (9, 1, 14, 0),
      "rgb": (240, 245, 229),
      "color": "#f0f5e5",
      "title": "嫩菊绿",
      "Py": "nenjulv"
    },
    {
      "CMYK": (20, 1, 23, 0),
      "rgb": (223, 236, 213),
      "color": "#dfecd5",
      "title": "艾背绿",
      "Py": "aibeilv"
    },
    {
      "CMYK": (47, 0, 49, 0),
      "rgb": (173, 213, 162),
      "color": "#add5a2",
      "title": "嘉陵水绿",
      "Py": "jialingshuilv"
    },
    {
      "CMYK": (89, 0, 96, 0),
      "rgb": (65, 179, 73),
      "color": "#41b349",
      "title": "玉髓绿",
      "Py": "yusuilv"
    },
    {
      "CMYK": (88, 0, 99, 0),
      "rgb": (67, 178, 68),
      "color": "#43b244",
      "title": "鲜绿",
      "Py": "xianlv"
    },
    {
      "CMYK": (90, 0, 100, 0),
      "rgb": (65, 174, 60),
      "color": "#41ae3c",
      "title": "宝石绿",
      "Py": "baoshilv"
    },
    {
      "CMYK": (18, 4, 33, 0),
      "rgb": (226, 231, 191),
      "color": "#e2e7bf",
      "title": "海沬绿",
      "Py": "haimeilv"
    },
    {
      "CMYK": (28, 4, 44, 0),
      "rgb": (208, 222, 170),
      "color": "#d0deaa",
      "title": "姚黄",
      "Py": "yaohuang"
    },
    {
      "CMYK": (44, 3, 61, 0),
      "rgb": (178, 207, 135),
      "color": "#b2cf87",
      "title": "橄榄石绿",
      "Py": "ganlanshilv"
    },
    {
      "CMYK": (62, 0, 76, 0),
      "rgb": (140, 194, 105),
      "color": "#8cc269",
      "title": "水绿",
      "Py": "shuilv"
    },
    {
      "CMYK": (42, 3, 67, 0),
      "rgb": (183, 208, 122),
      "color": "#b7d07a",
      "title": "芦苇绿",
      "Py": "luweilv"
    },
    {
      "CMYK": (28, 6, 66, 0),
      "rgb": (210, 217, 122),
      "color": "#d2d97a",
      "title": "槐花黄绿",
      "Py": "huaihuahuanglv"
    },
    {
      "CMYK": (41, 4, 76, 0),
      "rgb": (186, 207, 101),
      "color": "#bacf65",
      "title": "苹果绿",
      "Py": "pingguolv"
    },
    {
      "CMYK": (58, 1, 88, 0),
      "rgb": (150, 194, 78),
      "color": "#96c24e",
      "title": "芽绿",
      "Py": "yalv"
    },
    {
      "CMYK": (19, 9, 84, 1),
      "rgb": (226, 216, 73),
      "color": "#e2d849",
      "title": "蝶黄",
      "Py": "diehuang"
    },
    {
      "CMYK": (38, 8, 94, 1),
      "rgb": (190, 201, 54),
      "color": "#bec936",
      "title": "橄榄黄绿",
      "Py": "ganlanhuanglv"
    },
    {
      "CMYK": (81, 0, 100, 0),
      "rgb": (91, 174, 35),
      "color": "#5bae23",
      "title": "鹦鹉绿",
      "Py": "yingwulv"
    },
    {
      "CMYK": (84, 64, 94, 45),
      "rgb": (37, 61, 36),
      "color": "#253d24",
      "title": "油绿",
      "Py": "youlv"
    },
    {
      "CMYK": (0, 1, 4, 0),
      "rgb": (255, 254, 248),
      "color": "#fffef8",
      "title": "象牙白",
      "Py": "xiangyabai"
    },
    {
      "CMYK": (3, 5, 8, 0),
      "rgb": (248, 244, 237),
      "color": "#f8f4ed",
      "title": "汉白玉",
      "Py": "hanbaiyu"
    },
    {
      "CMYK": (0, 1, 3, 0),
      "rgb": (255, 254, 249),
      "color": "#fffef9",
      "title": "雪白",
      "Py": "xuebai"
    },
    {
      "CMYK": (4, 4, 8, 0),
      "rgb": (247, 244, 237),
      "color": "#f7f4ed",
      "title": "鱼肚白",
      "Py": "yudubai"
    },
    {
      "CMYK": (12, 12, 16, 0),
      "rgb": (228, 223, 215),
      "color": "#e4dfd7",
      "title": "珍珠灰",
      "Py": "zhenzhuhui"
    },
    {
      "CMYK": (16, 15, 20, 1),
      "rgb": (218, 212, 203),
      "color": "#dad4cb",
      "title": "浅灰",
      "Py": "qianhui"
    },
    {
      "CMYK": (28, 5, 30, 5),
      "rgb": (187, 181, 172),
      "color": "#bbb5ac",
      "title": "铅灰",
      "Py": "qianhui"
    },
    {
      "CMYK": (28, 25, 30, 5),
      "rgb": (187, 181, 172),
      "color": "#bbb5ac",
      "title": "中灰",
      "Py": "zhonghui"
    },
    {
      "CMYK": (42, 40, 43, 23),
      "rgb": (134, 126, 118),
      "color": "#867e76",
      "title": "瓦灰",
      "Py": "wahui"
    },
    {
      "CMYK": (43, 40, 44, 42),
      "rgb": (132, 124, 116),
      "color": "#847c74",
      "title": "夜灰",
      "Py": "yehui"
    },
    {
      "CMYK": (42, 42, 45, 27),
      "rgb": (128, 118, 110),
      "color": "#80766e",
      "title": "雁灰",
      "Py": "yanhui"
    },
    {
      "CMYK": (42, 42, 46, 27),
      "rgb": (129, 119, 110),
      "color": "#81776e",
      "title": "深灰",
      "Py": "shenhui"
    }
]
  

export default colorTermList